import SponsorFormConfirm from './container'

export default SponsorFormConfirm
